import useFetch from '../../hooks/useFetch';
import Api from '../../api';

const useRegister = () => {
  const { data, onSubmit } = useFetch('register', Api.REGISTER);

  const handleSubmit = (values) =>
    onSubmit({
      body: {
        ...values,
        confirmPassword: values.password,
      },
    });

  return {
    data,
    onSubmit: handleSubmit,
  };
};

export default useRegister;
